import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import debounce from "lodash/debounce";
import {injectIntl} from "react-intl";

import template from '../../../templates/PageLayout/Popups/AddEntityPopup.rt';
import {getAllFabricators, assignEntities, removeAllEntities} from '../../Fabricators/FabricatorsActions';
import {getAllStores} from '../../../actions/stores';
import {assignEntity} from '../../../actions';
import {
  showAssignEntityPopup, assignEntityPopupCheckName, assignEntityPopupCheckIsLicensedAdmin,
  assignEntityPopupSave, assignMultipleEntitiesProperty
} from '../../../actions/A_Popups';

const mapStateToProps = state => {
  const {assignEntity, entitiesLoading} = state.popups;
  const storePath = assignEntity.get('storePath');
  return {
    popup: assignEntity,
    storePath,
    entitiesLoading,
  }
};

const mapDispatchToProps = dispatch => ({
  getAllFabricators: (searchKeyword, filterBy, entityType, page = 0) => dispatch(getAllFabricators(searchKeyword, filterBy, entityType, page)),
  getAllStores: (entityId, filterBy, entityType, page = 0) => dispatch(getAllStores(entityId, filterBy, entityType, page)),
  showAssignEntityPopup: config => dispatch(showAssignEntityPopup(config)),
  assignEntityPopupCheckName: (itemId, checked) => dispatch(assignEntityPopupCheckName(itemId, checked)),
  assignMultipleEntitiesProperty: (propName, value) => dispatch(assignMultipleEntitiesProperty(propName, value)),
  assignEntityPopupCheckIsLicensedAdmin: (itemId, checked) => dispatch(assignEntityPopupCheckIsLicensedAdmin(itemId, checked)),
  assignEntityPopupSave: (storePath) => dispatch(assignEntityPopupSave(storePath)),

  searchFabricators: (value, userId) => {
    dispatch(getAllFabricators(value, userId));
  },
  searchStores: (value, userId) => {
    dispatch(getAllStores(value, userId));
  },
  assignEntity: (entityId, user, searchKeyword, popupType) => {
    dispatch(assignEntity(
      user.id,
      {entityId: entityId, isLicensedAdmin: false},
      searchKeyword,
      popupType
    ));
  },
  assignEntities: (masterEntity, childEntities, entityType) => dispatch(assignEntities(masterEntity, childEntities, entityType)),
  removeAllEntities: () => dispatch(removeAllEntities()),
});

class AddEntity extends Component {
  static propTypes = {
    // in case we need only to save in local store a fixed path is needed from ReduxStore
    // if this is empty, the saving
    storePath: PropTypes.string
  }
  constructor(props) {
    super(props);

    const {popup} = this.props;
    this.state = {
      searchText: '',
      page: 0,
      hideLicensedAdminCheckBoxes: popup.get('hideLicensedAdminCheckBoxes'),
      singleSelection: popup.get('singleSelection')
    };

    this.searchDebounce = null;
    switch (popup.get('entitiesType')) {
      case 'fabricators':
        this.searchDebounce = debounce(this.props.getAllFabricators, 250);
        break;
      case 'stores':
        this.searchDebounce = debounce(this.props.getAllStores, 250);
        break;
    }
  }

  componentDidMount() {
    const {popup} = this.props;
    switch (popup.get('entitiesType')) {
      case 'fabricators':
        this.props.getAllFabricators(this.state.searchText, popup.get('entityId'), popup.get('entityType'));
        break;
      case 'stores':
        this.props.getAllStores(this.state.searchText, popup.get('entityId'), popup.get('entityType'));
        break;
    }
  }

  componentWillUnmount() {
    this.props.removeAllEntities();
  }

  handleClose = () => {
    this.props.showAssignEntityPopup({visible: false});
  };

  handleSave = () => {
    this.props.assignEntityPopupSave(this.props.storePath)
  }

  handleSearchTextChanged = e => {
    const {popup} = this.props;
    const {value} = e.target;
    this.setState({searchText: value, page: 0}, () => {
      this.searchDebounce(value, popup.get('entityId'), popup.get('entityType'));
    });
  };

  allEntitiesChecked = (propName) => {
    const activeFabricatorIdJob = this.props.popup.get('activeFabricatorIdJob');
    const entities = this.props.popup.get('allEntities').toJS();
    // console.log("this.props.entities", entities);
    if (!Array.isArray(entities) || !entities.length) {
      return false
    }
    return entities.every(entity => {
      return activeFabricatorIdJob ? activeFabricatorIdJob === entity.id : entity[propName]
    })
  }

  handleAllEntitiesCheck = (propName) => {
    this.props.assignMultipleEntitiesProperty(propName, !this.allEntitiesChecked(propName));
  };

  handlePageClick = page => {
    const {searchText} = this.state;
    const {popup} = this.props;
    this.setState({page}, () => {
      this.searchDebounce(searchText, popup.get('entityId'), popup.get('entityType'), page - 1);
    })
  };

  render = template
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AddEntity)
);
